 export const myMixin = {
	data(){
	  return {
		  pid:'',//产品id加密串
		  productPrice:'',//产品价格
		  provinceCode:'',//省编码
		  provinceName:'',//省名称
		  cityCode:'',//城市编码
		  cityName:'',//城市名称
		  phoneNum:'', //业务员电话号码
		  qqNum:'',
		  wxNum:'',
		  wxPic:'',
	  }
	 },
} 